import * as o from "react";
import t from "../lib/IconBase.es.js";
import i from "../defs/Clipboard.es.js";
const r = o.forwardRef((a, e) => /* @__PURE__ */ o.createElement(t, { ref: e, ...a, weights: i }));
r.displayName = "ClipboardIcon";
const c = r;
export {
  c as Clipboard,
  r as ClipboardIcon
};
